module.exports = __webpack_public_path__ + "static/media/link-existing-product.0852193a.gif";